var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoreFrontSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    transform: "translate(-219 -4925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1160",
    "data-name": "Rectangle 1160",
    width: 77,
    height: 77,
    transform: "translate(219 4925)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NFT_Tools",
    "data-name": "NFT Tools",
    transform: "translate(233.6 4941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M16.9,4.7A8.423,8.423,0,0,1,27.7,9.8a8,8,0,0,1,0,5.7L53.8,41.6l-5.1,5.1L22.5,20.6a8.423,8.423,0,0,1-10.8-5.1,8,8,0,0,1,0-5.7l5.4,5.4a3.607,3.607,0,0,0,5.2-5l-.1-.1L16.9,4.7Z",
    transform: "translate(-9.959 -4.191)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M44,8.5l7.6-4.3L55,7.6l-4.2,7.7-4.3.9L17.3,45.3l-3.4-3.4L43.1,12.7Z",
    transform: "translate(-9.959 -4.191)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M22.9,31.2,28,36.3,16.1,48.2a3.621,3.621,0,0,1-5.1,0,3.544,3.544,0,0,1-.2-4.8l.2-.3L22.9,31.2Z",
    transform: "translate(-9.959 -4.191)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M33.949,21.893l-5.092,5.091,3.4,3.394,5.09-5.09-3.393-3.4Z",
    transform: "translate(-9.959 -4.191)",
    fill: "#004890"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreFrontSetting);
export default __webpack_public_path__ + "static/media/StoreFrontSetting.1a33d2288c256caaf9659331482fbb26.svg";
export { ForwardRef as ReactComponent };